import { callExternalApi } from '../callExternalApi';

/**
 * Fetches a KML icon image with a server-side colour tint applied.
 *
 * The backend replicates the multiply-blend tinting that Google's deprecated KmlLayer
 * applied automatically: each output channel = source_channel * (color_channel / 255).
 *
 * @param iconUrl - The original https icon URL from the KML file.
 * @param color   - 6-character lowercase RGB hex string (e.g. "ff0000"), derived from
 *                  the KML ABGR <color> element after togeojson converts it.
 * @param opacity - Icon alpha multiplier in [0, 1], derived from the KML <color> alpha byte.
 */
export const fetchTintedKmlIcon = (iconUrl: string, color: string, opacity: number) => {
  const params = new URLSearchParams({ url: iconUrl, color });
  if (opacity !== 1) params.set('opacity', opacity.toFixed(4));
  return callExternalApi<Blob>({
    url: `api/kml/icon_proxy?${params.toString()}`,
    method: 'GET',
    headers: { accept: 'image/*' },
    responseType: 'blob'
  });
};
